var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "mails" } },
    [
      _c("a-spin", { attrs: { spinning: _vm.loading } }, [
        _vm.allMailCounts > 0
          ? _c("div", { staticClass: "row container" }, [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    width: "calc(100vw - 500px)",
                  },
                },
                [
                  _c("MailBox", {
                    staticClass: "col-md-3",
                    attrs: { refreshMailList: _vm.refreshMailList },
                    on: {
                      "visible-composer": function (e) {
                        _vm.isVisibleComposer = e
                      },
                      mailDetails: function (e) {
                        return (_vm.mailDetails = e)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm.isVisibleComposer
                    ? _c("MailComposer", {
                        attrs: {
                          isNewMail: true,
                          mailDetails: _vm.mailDetails,
                        },
                        on: {
                          closeEditor: function ($event) {
                            _vm.isVisibleComposer = false
                          },
                          newMailDetail: function (e) {
                            return (_vm.newMailDetail = e)
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isVisibleComposer && _vm.mailDetails.length > 0
                    ? _c("ThreadViewer", {
                        staticClass: "col-md-9",
                        staticStyle: { height: "calc(100vh - 200px)" },
                        attrs: {
                          composerView: _vm.isVisibleComposer,
                          isUserMailDetail: true,
                          mailDetails: _vm.mailDetails,
                          mailDetailPage: _vm.selectedMail,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ])
          : _c("div", { staticClass: "data-box" }, [
              _c("div", { staticClass: "last-session-info" }, [
                _c(
                  "div",
                  {
                    staticClass: "material-icons",
                    staticStyle: { "font-size": "20px" },
                  },
                  [_vm._v("block")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "last-session-data",
                    staticStyle: { "margin-top": "5px" },
                  },
                  [_vm._v("No user data were found")]
                ),
              ]),
            ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }